import React, { Component } from 'react';
import './App.css';
import AppBar from 'material-ui/AppBar';
import DrawerMenu from './DrawerMenu.js'

class NavMenu extends Component {
    render() {
        return (
            <div>
                <AppBar
                    style={{backgroundColor: "#5a5598"}}
                    title={<span><img className="banner" src="./img/banner.png" alt="Leaping Libby" /><span className="compTitle">{this.props.compTitle}</span></span>}
                    iconClassNameRight="muidocs-icon-navigation-expand-more"
                    iconElementLeft={<DrawerMenu setSource={(vidSource, event) => this.props.setSource(vidSource, event)} />}
                />
            </div>
        );
    }
}

export default NavMenu;



// WEBPACK FOOTER //
// ./src/NavMenu.js